import React, { useCallback, useEffect, useRef } from "react";
import { useParams, useLocation, Link } from "react-router-dom";

import CloudIcon from './cloud.svg?react'
import "./index.css";
import classes from "./App.module.css";
import Triangles from "./Triangles.jsx";

export default function App() {
  return (
    <div>
      <Triangles/>
      <CloudIcon className={classes.icon} />
    </div>
  );
}
